import { toast } from "sonner";
import { CMS_PAGES } from "../../data/adminData";
import { PageTitle, Table, Badge, Btn, dt } from "./ui";

export default function CmsPages() {
  return (
    <div data-testid="admin-cms">
      <PageTitle right={<Btn variant="red" onClick={() => toast.info("Jauna CMS lapa (DEMO)", { description: "Pilnajā versijā atvērtos satura redaktors." })} data-testid="cms-add">+ Jauna lapa</Btn>}>
        CMS lapas ({CMS_PAGES.length})
      </PageTitle>
      <Table head={["Lapa", "URL", "Statuss", "Atjaunota", ""]}>
        {CMS_PAGES.map((p) => (
          <tr key={p.id} className="border-b border-[#F5F5F5] hover:bg-[#F5F5F5]" data-testid={`cms-row-${p.id}`}>
            <td className="p-3 font-bold">{p.title}</td>
            <td className="text-[#6B6B6B] font-mono text-xs">{p.slug}</td>
            <td><Badge color={p.status === "Publicēta" ? "green" : "gray"}>{p.status}</Badge></td>
            <td className="text-[#6B6B6B]">{dt(p.updated)}</td>
            <td className="p-3"><Btn variant="outline" onClick={() => toast.success("Satura redaktors atvērts (DEMO)")} data-testid={`cms-edit-${p.id}`}>Rediģēt</Btn></td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
